import * as angular from 'angular';

"use strict";

angular.module('ResetForgotPasswordModule', [])

export default 'ResetForgotPasswordModule';
